// src/services/promesasCumplimientoAuto.js
//
// Detección automática de cumplimiento de promesas.
// Después de un pago, busca promesas pendientes de la misma deuda con
// fechaPromesa dentro de ±2 días del pago, y las marca como cumplidas.
//
// Es fire-and-forget: no bloquea el flujo de pago si falla.

import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../Firebase/firebaseconfig";
import { marcarPromesaCumplida } from "./cobranzaOperativaService";
import { toJsDate } from "../helpers/fechas";

const TOLERANCIA_DIAS = 2;

/**
 * Busca promesas pendientes de la deuda con fechaPromesa cercana a fechaPago
 * y las cierra automáticamente.
 *
 * @param {string} deudaId
 * @param {Date|string} fechaPago — momento del pago
 * @param {object} info — { pagoId, cajaMovimientoId, monto }
 * @returns {Promise<number>} cantidad de promesas marcadas como cumplidas
 */
export async function cerrarPromesasPorPago(deudaId, fechaPago, info = {}) {
  if (!deudaId) return 0;

  try {
    const fp = new Date(fechaPago || Date.now());
    if (Number.isNaN(fp.getTime())) return 0;

    const q = query(
      collection(db, "promesasPago"),
      where("deudaId", "==", deudaId),
      where("estado", "==", "pendiente"),
    );
    const snap = await getDocs(q);
    if (snap.empty) return 0;

    let cerradas = 0;
    for (const docSnap of snap.docs) {
      const promesa = docSnap.data() || {};
      const fechaPromesaStr = promesa.fechaPromesa;
      if (!fechaPromesaStr) continue;

      const fProm = toJsDate(fechaPromesaStr);
      if (!fProm || Number.isNaN(fProm.getTime())) continue;
      fProm.setHours(0, 0, 0, 0);

      const diffDias = Math.abs((fp.getTime() - fProm.getTime()) / 86400000);
      if (diffDias <= TOLERANCIA_DIAS) {
        try {
          await marcarPromesaCumplida(docSnap.id, {
            montoRecibido: Number(info.monto || 0),
            pagoId: info.pagoId || "",
            cajaMovimientoId: info.cajaMovimientoId || "",
            notas: `Cierre automático: pago detectado a ${Math.round(diffDias)} días de la promesa.`,
          });
          cerradas++;
        } catch (err) {
          console.warn(`Error cerrando promesa ${docSnap.id}:`, err);
        }
      }
    }
    return cerradas;
  } catch (err) {
    console.warn("cerrarPromesasPorPago error:", err);
    return 0;
  }
}
